module.exports = __webpack_public_path__ + "media/assets/images/logs1_300x200-6304381aea36f2bafe8352317097408c.jpg";